import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useAppSelector } from '../../../../redux/store';
import { NUM_TOTAL_COMMUNITY_CARDS } from '../../../../types/cardTypes';
import { CardDisplay } from '../cardDisplay';
function getCardEmphasis(cardEmphasis, isIn) {
    // If the player is not active in the hand, don't outline the card.
    // In a multi-way pot, if a player had outlined cards but folds and the hand is not over yet,
    // this ensures the outline no longer shows:
    // TODO: Consider setting this in the reducer when the player folds.
    if (!isIn && cardEmphasis === 'outlined') {
        return 'normal';
    }
    return cardEmphasis;
}
function getAnimationProps(cardEmphasis, currentShowdownStartTimestampMs, communityCardStartTimestampMs) {
    if (currentShowdownStartTimestampMs !== undefined) {
        // in a showdown, prioritize this animation over any 'show' animations for this card
        return {
            startTimestampMs: currentShowdownStartTimestampMs,
            animationType: cardEmphasis === 'highlighted' ? 'ranked' : 'non-ranked'
        };
    }
    if (communityCardStartTimestampMs !== undefined) {
        return {
            startTimestampMs: communityCardStartTimestampMs,
            animationType: 'show'
        };
    }
    return {};
}
export const LiveCommunityCardDisplay = ({ communityCardIndex, cardRenderProperties, isIn, isFourColorDeckEnabled }) => {
    const cardRankChar = useAppSelector((state) => state.poker.communityCards[communityCardIndex]?.card.rankChar);
    const cardSuitChar = useAppSelector((state) => state.poker.communityCards[communityCardIndex]?.card.suitChar);
    const cardEmphasis = useAppSelector((state) => state.poker.communityCards[communityCardIndex]?.cardEmphasis);
    const currentShowdownStartTimestampMs = useAppSelector((state) => state.poker.currentShowdown?.startTimeStampMs);
    const communityCardStartTimestampMs = useAppSelector((state) => state.poker.communityCards[communityCardIndex]?.performanceTimestampMs);
    if (!cardRankChar || !cardSuitChar || !cardEmphasis) {
        return null;
    }
    return (_jsx(CardDisplay, { pixiDataType: 'community-card', cardRankChar: cardRankChar, cardSuitChar: cardSuitChar, cardIndex: communityCardIndex, cardEmphasis: getCardEmphasis(cardEmphasis, isIn), cardRenderProperties: cardRenderProperties, numCardsInGroup: NUM_TOTAL_COMMUNITY_CARDS, isFourColorDeck: isFourColorDeckEnabled, dropShadowAlpha: 0.3, ...getAnimationProps(cardEmphasis, currentShowdownStartTimestampMs, communityCardStartTimestampMs) }));
};
